
import { defineComponent, inject, ref, watch, provide } from 'vue'
//import type { FormInstance, FormRules } from "element-plus";
import { ArrowLeft } from '@element-plus/icons-vue'
//import { training, condition, matricule, cycle } from "@/core/data/shared"
//Components
import sFiles from "@/components/wizard/steps/sFiles.vue"
import sAcademic from '@/components/wizard/steps/StepAcademic.vue';
import sCompetition from '@/components/wizard/steps/StepCompetition.vue';
import sOficial from '@/components/wizard/steps/StepOficial.vue'

//services
import AcrdService from '@/core/services/AcrdService';
import EventService from '@/core/services/EventService';
import FileService from "@/core/services/FileService";
import personService from "@/core/services/PersonService"
import { errManager, mbtoa } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    components: { sFiles, sAcademic, sCompetition, sOficial },
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        action: {
            type: Number,
            required: true,
            default: 1
        },
        typeRegister: {
            type: String,
            required: true,
            default: ''
        },
        setting: {
            type: null,
            required: true,
            default: {}
        }
    },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const url = ref(process.env.VUE_APP_REPO);
        const altura = screen.height;
        const loader = ref<boolean>(false)
        const loaderPhoto = ref<boolean>(false)
        const titleModal = ref('')
        const gblDialogAcrd = inject<any>('gblDialogAcrd')
        const rowAcrd = inject<any>('rowAcrd') //obtener la preinfo que será asignada a la etiqueta form
        const photo = ref<any>({})
        const gblPhoto = inject<any>('gblPhoto')
        const gblDataPhoto = inject<any>('gblDataPhoto')
        const dialogPhoto = inject<any>('dialogPhoto')

        //steps
        const activeStep = ref(-1)
        const totalSteps = ref(0)
        const childComponentRef = ref<any>(null)

        const listTypeFile = ref<any[]>([])
        const filesUploads = ref<any[]>([])
        const listFunctions = ref<any>([])
        provide("listTypeFile", listTypeFile)
        provide("filesUploads", filesUploads)


        const onOpened = () => {
            activeStep.value = 0
            totalSteps.value = 1
            if (props.typeRegister == 'D') {
                totalSteps.value = 2
            }
            getListTypeFile()
            getFunctions()
            getPhoto()
        }

        const onClosed = () => {
            activeStep.value = -1
            totalSteps.value = 0
            rowAcrd.value = {}
            loaderPhoto.value = false
            photo.value = {}
        }

        const backStep = () => {
            activeStep.value--
        }

        const getPhoto = async () => {
            loaderPhoto.value = true
            personService.getPhoto({ idperson: rowAcrd.value.idperson })
                .then((res) => {
                    loaderPhoto.value = false
                    photo.value = res.data
                }).catch(({ response }) => {
                    loaderPhoto.value = false
                })
        }

        const onDialogPhoto = () => {
            gblDataPhoto.value = {
                target: 'photo',
                id: mbtoa(rowAcrd.value.idperson)
            }
            dialogPhoto.value = true
        }

        /*
        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };
        */

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await FileService.getFiles2('acrd', 'type', { tregister: rowAcrd.value.tregister, idevent: rowAcrd.value.idevent, idsport: rowAcrd.value.idsport })
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        const getFormData = () => {
            if (activeStep.value == (totalSteps.value))
                onSaveClose()
            else {
                if (childComponentRef.value) {
                    childComponentRef.value.formRef.validate((valid: boolean) => {
                        if (valid) {
                            if ('target' in childComponentRef.value.form)
                                onUpdateCmp()
                            else
                                onSaveUpdate()
                        }
                    });
                    //console.log(childComponentRef.value.form);
                    // Aquí puedes manipular los datos del formulario
                    //alert(`Nombre: ${childComponentRef.value.form.acondition}, Email: ${childComponentRef.value.form.studentcode}`);
                }
            }

        };

        const onSaveUpdate = async () => {
            loader.value = true
            Object.assign(rowAcrd.value, childComponentRef.value.form)
            let target = ('idacreditation' in rowAcrd.value) ? 'update' : 'register'
            await AcrdService.options(target, rowAcrd.value)
                .then((res) => {
                    loader.value = false
                    if (res.data.status == 'success') {
                        rowAcrd.value = res.data.acrd
                        activeStep.value++;
                    } else {
                        Swal.fire({
                            icon: res.data.status,
                            title: res.data.title,
                            html: res.data.message
                        })
                    }
                    //console.log(rowAcrd.value)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onUpdateCmp = async () => {
            //console.log(childComponentRef.value.form)
            loader.value = true
            Object.assign(rowAcrd.value, childComponentRef.value.form)
            await AcrdService.options('change-public', rowAcrd.value)
                .then((res) => {
                    loader.value = false
                    if (res.data.status == 'success') {
                        activeStep.value++;
                    } else {
                        Swal.fire({
                            icon: res.data.status,
                            title: res.data.title,
                            html: res.data.message
                        })
                    }
                    //console.log(rowAcrd.value)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onSaveClose = () => {
            gblDialogAcrd.value = false
            emit("onResponse", { status: 'success' })
        }

        const getFunctions = async () => {
            await EventService.options('functions', { idevent: rowAcrd.value.idevent, idsport: rowAcrd.value.idsport })
                .then((res) => {
                    listFunctions.value = res.data
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        watch(() => gblPhoto.value, getPhoto);

        return {
            t,
            url,
            altura,
            loader,
            loaderPhoto,
            photo,
            titleModal,
            rowAcrd,
            gblDialogAcrd,
            activeStep,
            totalSteps,
            //icons
            ArrowLeft,
            listTypeFile,
            listFunctions,
            //events
            onOpened,
            onClosed,
            getListTypeFile,
            backStep,
            getFunctions,
            childComponentRef,
            getFormData,
            onDialogPhoto
        }
    },
})
